import React from "react";
import ReactDOM from "react-dom/client";
import { HMSRoomProvider } from "@100mslive/react-sdk";

import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { WorkshopProvider } from "./contexts/workshop.context";

import reportWebVitals from "./reportWebVitals";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <HMSRoomProvider>
      <WorkshopProvider>
        <App />
      </WorkshopProvider>
    </HMSRoomProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
